import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Balance_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Balance_Report() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  // 1. States for Data and Filters
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filter States
  const [selectedAcademic, setSelectedAcademic] = useState("cay25");
  const [searchTerm, setSearchTerm] = useState("");

  // 2. Fetch Logic
  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        academic: selectedAcademic,
        search: searchTerm,
        page: 1,
        limit: 10,
      };

      const response = await simplePostCall(
        ApiConfig.termwiseRports,
        JSON.stringify(payload),
      );

      // Check if response exists and contains the 'data' array from your JSON sample
      if (response && response.result) {
        setReportData(response.data || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  }, [selectedAcademic, searchTerm]);

  // 3. Initial Load
  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchInitialData();
  };

  return (
    <div
      className="balance_data_report-container"
      style={{ paddingTop: "25px" }}
    >
      {/* Header */}
      <div className="balance_data_report-header">
        <h3 className="balance_data_report-title">Balance Report</h3>

        <button
          style={{ backgroundColor: "var(--color-primary)" }}
          className="btn btn-sm text-white"
        >
          Export
        </button>
      </div>

      <div className="balance_data_report-row">
        <div className="balance_data_report-col">
          <div className="balance_data_report-panel">
            <div className="balance_data_report-panel-body">
              <div className="balance_data_report-table-responsive">
                {/* Table Header */}
                <div
                  style={{
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "10px",
                    marginTop: '25px'
                  }}
                 
                >
                  <form onSubmit={handleSearch} className="d-flex gap-2">
                    <div className="balance_data_report-filter-item">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Student..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    <div className="balance_data_report-filter-item ">
                      <select
                        className="balance_data_report-select form-select"
                        value={selectedAcademic}
                        onChange={(e) => setSelectedAcademic(e.target.value)}
                      >
                        <option value="cay25">2024-2025</option>
                        <option value="cay24">2023-2024</option>
                      </select>
                    </div>

                    <div className="balance_data_report-filter-item">
                      <button
                        style={{
                          backgroundColor: "var(--color-primary)",
                          color: "white",
                          border: "none",
                        }}
                        type="submit"
                        className="btn"
                        disabled={loading}
                      >
                        {loading ? "Searching..." : "Search"}
                      </button>
                    </div>
                  </form>
                </div>
                <table className="balance_data_report-table">
                  {/* Table Header */}
                  <thead>
                    <tr colSpan="7">
                      <th style={{ textAlign: "center" }}>Sr.No</th>
                      <th style={{ textAlign: "center" }}>Adm. No</th>
                      <th style={{ textAlign: "center" }}>Student Name</th>
                      <th style={{ textAlign: "center" }}>Class/Sec</th>
                      <th style={{ textAlign: "center" }}>Total Invoiced</th>
                      <th style={{ textAlign: "center" }}>Paid</th>
                      <th style={{ textAlign: "center" }}>Balance</th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* Loader */}
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="text-center">
                          <div className="text-center">
                            <ScaleLoader
                              color="#F4BB44"
                              style={{ textAlign: "center", padding: "10px" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportData.length > 0 ? (
                      /* Data Rows */
                      reportData.map((item, index) => (
                        <tr key={item.student_id || index}>
                          <td>{index + 1}</td>
                          <td>{item.student_admission_num}</td>
                          <td>{item.student_name}</td>
                          <td>
                            {item.class_name} - {item.section_name}
                          </td>
                          <td>{customer_currency} {formatNumber(item.total_invoiced)}</td>
                          <td>{customer_currency} {formatNumber(item.total_paid)}</td>
                          <td className="text-danger fw-bold">
                            {customer_currency} {formatNumber(item.balance)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      /* No Data */
                      <tr>
                        <td
                          colSpan="7"
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Balance_Report;
